import React from "react";

const ScenarioIntro = () => {
    return (
        <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '100px 0',
            minHeight: '40vh',
        }}>
            <div style={{
                fontSize: '2.5em',
                fontWeight: 700,
                marginBottom: 32,
                textAlign: 'center',
                color: '#1976d2',
            }}>
                <span role="img" aria-label="lightbulb" style={{fontSize: '1.2em', marginRight: 12}}>💡</span>
                Now, let's see a couple of examples together!
                <span role="img" aria-label="eyes" style={{fontSize: '1.2em', marginLeft: 12}}></span>
            </div>
            <div style={{
                fontSize: '1.5em',
                color: '#444',
                textAlign: 'center',
                maxWidth: 600,
            }}>
                These examples will help you understand how the game works before you begin playing.
            </div>
        </div>
    );
};

export default ScenarioIntro; 